<script setup>
import { ErrorMessage, Field } from "vee-validate";

const model = defineModel();

const props = defineProps({
  fieldId: {
    type: String,
    required: true,
  },
  fieldName: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  placeholder: {
    type: String,
    required: false,
  },
  legend: {
    type: String,
    required: false,
  },
  rows: {
    type: [Number, String],
    required: false,
    default: 5,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  resize: {
    type: String,
    required: false,
    default: 'both',
  },
});
</script>

<template>
  <div class="mb-4 flex flex-col">
    <label v-if="props.label" :for="props.fieldName" class="mb-2">
      {{ props.label }}
      <sup v-if="props.required" class="text-red-500">*</sup>
    </label>

    <Field
      :id="props.fieldId"
      :name="props.fieldName"
      as="textarea"
      :rows="props.rows"
      :disabled="props.disabled"
      :placeholder="props.placeholder"
      v-model="model"
      class="rounded border border-gray-300 px-5 py-3 ring-1 ring-transparent duration-150 placeholder:text-gray-400 focus:outline-0 focus:ring-gray-300 disabled:cursor-not-allowed disabled:bg-gray-100"
      :style="{ resize: props.resize }"
    />

    <em v-if="props.legend" class="mt-1 text-xs text-gray-400">
      {{ props.legend }}
    </em>

    <ErrorMessage :name="props.fieldName" class="mt-1 text-sm text-red-500" />
  </div>
</template>
